const registrationForm = () => {
  const registerWrapper = document.querySelector(".customer.register")
  const alreadyRegisteredLink = registerWrapper.querySelector(
    ".already_registered a",
  )
  const signUpForm = registerWrapper.querySelector("form#create_customer")
  const registerButton = signUpForm.querySelector("button#RegisterButton")
  const firstName = signUpForm.querySelector(
    "input[name='customer[first_name]']",
  )
  const lastName = signUpForm.querySelector("input[name='customer[last_name]']")
  const email = signUpForm.querySelector("input#RegisterForm-email")
  const password = signUpForm.querySelector("input#RegisterForm-password")
  const passwordConfirm = signUpForm.querySelector(
    "input#RegisterForm-confirmPassword",
  )
  const optIn = signUpForm.querySelector("input#RegisterForm-optIn")
  const thisModal = signUpForm.closest("modal-dialog")

  const init = () => {
    alreadyRegisteredLink.addEventListener("click", (event) => {
      event.preventDefault()
      const link = event.target
      const loginModal = document.querySelector(".login-modal")
      // if within a modal
      if (thisModal && loginModal) {
        // update modal contents
        thisModal.hide()
        loginModal.show()
      } else {
        // otherwise follow link
        window.location.href = link.getAttribute("href")
      }
    })

    registerButton.addEventListener("click", customerRegister)

    const urlSearchParams = new URLSearchParams(window.location.search)
    if (urlSearchParams) {
      const entries = urlSearchParams.entries()
      if (entries && entries.forEach) {
        entries.forEach(([key, value]) => {
          if (key === "password") {
            return
          }
          const input = document.querySelector(`input[name='customer[${key}]']`)
          if (input) {
            input.value = value
          }
        })
      }
    }

    // init password fields
    const registerPasswords = signUpForm.querySelectorAll(
      "input[type='password']",
    )
    for (idx in registerPasswords) {
      const pwInput = registerPasswords[idx]
      if (typeof pwInput === "object") {
        const inputWrapper = pwInput.closest(".field")
        const toggleBtnHTML = `<button class="password-visible__toggle" type="button" aria-pressed="false" aria-controls="pWord">
        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60"><path d="M59.715 28.969C59.238 28.176 47.863 9.594 30 9.594S.762 28.176.285 28.969a2.013 2.013 0 0 0 0 2.062C.762 31.824 12.137 50.406 30 50.406s29.238-18.582 29.715-19.375a2.013 2.013 0 0 0 0-2.062ZM30 0" stroke="#252525" fill="#252525"/><path d="M30 16.496c-7.445 0-13.504 6.059-13.504 13.504 0 7.445 6.059 13.504 13.504 13.504 7.445 0 13.504-6.059 13.504-13.504 0-7.445-6.059-13.504-13.504-13.504Zm0 23c-5.238 0-9.496-4.262-9.496-9.496 0-5.238 4.258-9.496 9.496-9.496s9.496 4.258 9.496 9.496c0 5.234-4.258 9.496-9.496 9.496Zm0 0" stroke="#fff" fill="#fff"/><path d="M30 24.824a5.175 5.175 0 1 0 0 10.348 5.174 5.174 0 1 0 0-10.348Zm0 0" stroke="#252525" fill="#252525"/></svg>
        <span class="visually-hidden">Show password</span>
        </button>`
        inputWrapper.insertAdjacentHTML("beforeend", toggleBtnHTML)
        const toggleBtn = inputWrapper.querySelector(
          ".password-visible__toggle",
        )
        inputWrapper.setAttribute("role", "group")
        inputWrapper.setAttribute("aria-labelledby", "pWord")
        toggleBtn.addEventListener("click", () => {
          togglePasswordVisibility(inputWrapper)
        })
        pwInput.addEventListener("keyup", checkValidPasswords)
      }
    }
    password.addEventListener("blur", (evt) => {
      if (!password.checkValidity()) {
        displayErrorMessage(password)
      }
    })
    passwordConfirm.addEventListener("blur", (evt) => {
      if (passwordConfirm.value !== password.value) {
        displayErrorMessage(passwordConfirm)
      }
    })

    // init text fields
    const registerTexts = signUpForm.querySelectorAll(
      "input[type='text'],input[type='email']",
    )
    for (idx in registerTexts) {
      const txtInput = registerTexts[idx]
      if (typeof txtInput === "object") {
        txtInput.addEventListener("keyup", (evt) => {
          const txtInput = evt.target
          if (txtInput.closest(".field").classList.contains("error")) {
            if (txtInput.checkValidity()) {
              hideErrorMessages(txtInput)
            }
          }
        })
        txtInput.addEventListener("blur", (evt) => {
          txtInput.value = txtInput.value.trim()
          if (!txtInput.checkValidity()) {
            displayErrorMessage(txtInput)
          }
        })
      }
    }
  }

  const errorContainer = signUpForm.querySelector(".form-error-container")
  const errorMessage = errorContainer.querySelector(".form-error-message")
  const displayErrorMessage = (input, message) => {
    if (input) {
      const field = input.closest(".field")
      const errorMsg = field.nextElementSibling
      field.classList.add("error")
      errorMsg.classList.remove("hidden")
      input.setAttribute("aria-invalid", "true")
      input.setAttribute(
        "aria-describedby",
        "Error-" + input.getAttribute("id"),
      )
      if (message) {
        errorMsg.innerHTML = message
      } else {
        errorMsg.innerHTML = errorMsg.getAttribute("data-default")
      }
    }
  }

  const hideError = (input) => {
    const field = input.closest(".field")
    const errorMsg = field.nextElementSibling
    field.classList.remove("error")
    errorMsg.innerHTML = ""
    errorMsg.classList.add("hidden")
    input.removeAttribute("aria-invalid")
    input.removeAttribute("aria-describedby")
  }
  const hideErrorMessages = (input, delay = 0) => {
    if (input) delay = 200
    let inputs = input ? [input] : signUpForm.querySelectorAll(".field > input")
    for (idx in inputs) {
      let input = inputs[idx]
      if (typeof input === "object") {
        if (delay) {
          setTimeout(hideError, delay, input)
        } else {
          hideError(input)
        }
      }
    }
    errorContainer.classList.add("hidden")
    errorMessage.textContent = ""
  }

  const checkValidPasswords = (evt) => {
    const pwInput = evt.target
    const isConfirm = pwInput.classList.contains("confirm")
    if (pwInput.closest(".field").classList.contains("error")) {
      if (
        (isConfirm && passwordConfirm.value === password.value) ||
        (!isConfirm && pwInput.checkValidity())
      ) {
        hideErrorMessages(pwInput)
      }
    }
    if (!passwordConfirm.closest(".field").classList.contains("hidden")) {
      // validate passwords match
      if (
        password.value.length > 0 &&
        password.value === passwordConfirm.value
      ) {
        $("#pwValidMatch", signUpForm).addClass("good")
        hideErrorMessages(passwordConfirm)
      } else {
        $("#pwValidMatch", signUpForm).removeClass("good")
        if (passwordConfirm.value.length > 0) {
          displayErrorMessage(passwordConfirm)
        }
      }
    }
    if (!isConfirm) {
      // validate length, uppercase, number
      if (password.value.length >= 8) {
        $("#pwValidLength", signUpForm).addClass("good")
      } else {
        $("#pwValidLength", signUpForm).removeClass("good")
      }
      if (/[A-Z]/.test(password.value)) {
        $("#pwValidLetter", signUpForm).addClass("good")
      } else {
        $("#pwValidLetter", signUpForm).removeClass("good")
      }
      if (/[\d]/.test(password.value)) {
        $("#pwValidNumber", signUpForm).addClass("good")
      } else {
        $("#pwValidNumber", signUpForm).removeClass("good")
      }
    }
  }

  const togglePasswordVisibility = (field, setVisible) => {
    const toggleBtn = field.querySelector(".password-visible__toggle")
    const pwInput = field.querySelector("input")
    const announce = field.querySelector(".announce")
    if (
      (typeof setVisible === "boolean" && setVisible) ||
      toggleBtn.getAttribute("aria-pressed") === "false"
    ) {
      toggleBtn.setAttribute("aria-pressed", "true")
      pwInput.setAttribute("type", "text")
      announce.textContent = "Your password is shown!"
    } else if (
      (typeof setVisible === "boolean" && !setVisible) ||
      toggleBtn.getAttribute("aria-pressed") === "true"
    ) {
      toggleBtn.setAttribute("aria-pressed", "false")
      pwInput.setAttribute("type", "password")
      announce.textContent = "Your password is hidden!"
    }
  }

  const getSiteRegion = () => {
    let region = window.Shopify?.theme?.name?.match(
      /\/(anz|ca|eu|uk|us)\//,
    )?.[1]
    if (!region) {
      region = location.hostname?.match(/-(anz|ca|eu|uk|us)[-.]/)?.[1]
    }
    return region || "us"
  }

  const customerRegister = async (event) => {
    event.preventDefault()
    hideErrorMessages()
    let errors = false
    if (!firstName.checkValidity()) {
      displayErrorMessage(firstName)
      errors = true
    }
    if (!lastName.checkValidity()) {
      displayErrorMessage(lastName)
      errors = true
    }
    if (!email.checkValidity()) {
      displayErrorMessage(email)
      errors = true
    }
    if (!password.checkValidity()) {
      displayErrorMessage(password)
      errors = true
    }
    if (!passwordConfirm.closest(".field").classList.contains("hidden")) {
      if (passwordConfirm.value !== password.value) {
        displayErrorMessage(passwordConfirm)
        errors = true
      }
    }
    if (errors) return

    if (password.getAttribute("type") === "text") {
      togglePasswordVisibility(password.closest(".field"), false)
    }
    if (passwordConfirm.getAttribute("type") === "text") {
      togglePasswordVisibility(passwordConfirm.closest(".field"), false)
    }

    try {
      const emailTrimmed = email.value.trim()
      const encPassword = btoa(password.value) // TODO implement encryption in transit
      registerButton.disabled = true
      const body = {
        event: "sign-up",
        email: emailTrimmed,
        password: encPassword,
        firstName: firstName.value.trim(),
        lastName: lastName.value.trim(),
        locale: `${window.Shopify.locale}-${window.Shopify.country}`,
        region: getSiteRegion(),
      }
      if (optIn.checked) {
        body.optin = 1
      }
      const response = await fetch("/apps/custom-events", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
      const responseJson = await response.json()

      if (response.status !== 200) {
        registerButton.disabled = false
        const errorMsg = signUpForm.querySelector("#" + responseJson.message)
        if (errorMsg) {
          displayErrorMessage(email, errorMsg.innerHTML)
          return
        }
        errorContainer.classList.remove("hidden")
        errorMessage.textContent = responseJson.message
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        })

        dataLayer.push({
          event: "sign_up_failure",
          message: responseJson.message,
          page_location: window.location.href,
        })

        return
      }
      signUpForm.reset()

      dataLayer.push({
        event: "sign_up",
        method: "email",
        page_location: window.location.href,
      })

      if (responseJson?.payload?.UserConfirmed == false) {
        document
          .querySelectorAll(
            ".customer.register h1, .customer.register .already_registered, .customer.register form",
          )
          .forEach((element) => {
            element.style.display = "none"
          })

        const acntConf = document.querySelector("account-confirmation")
        acntConf.initialize(emailTrimmed, encPassword)
      } else {
        // should no longer hit this block since registration now requires confirmation
        console.warn("Response: ", JSON.stringify(responseJson))
        location.href = responseJson.return_to.toString() // let error get caught if return_to is not set
      }
    } catch (error) {
      registerButton.disabled = false
      errorContainer.classList.remove("hidden")
      errorMessage.textContent = "Unexpected error"
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
      console.error(error)
    }
  }
  init()
}
registrationForm()
